<form [formGroup]="agreementForm">
    <app-form-section formGroupName="details">
        <app-form-row>
            <app-form-group class="report-container" #leftContainer>
                <div class="box">
                    <app-general-attributes
                        [detailsForm]="detailsForm"
                        [showPotentialValidationMessages]="true"
                    ></app-general-attributes>
                </div>
                <div class="box">
                    <app-agreement-parts
                        [detailsForm]="detailsForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-parts>
                </div>
                <div class="box" *ngIf="realEstateForm">
                    <app-agreement-real-estate
                        [realEstateForm]="realEstateForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-real-estate>
                </div>
                <div class="box" *ngIf="rentalForm">
                    <app-agreement-rental
                        [rentalForm]="rentalForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-rental>
                </div>
                <div class="box" *ngIf="inventoryForm">
                    <app-agreement-inventory
                        [inventoryForm]="inventoryForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-inventory>
                </div>
                <div class="box" *ngIf="paymentForm">
                    <app-agreement-payment
                        [paymentForm]="paymentForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-payment>
                </div>
            </app-form-group>
            <app-form-group class="report-container">
                <div class="box pdf-container">
                    <app-pdf-viewer
                        [id]="'file1'"
                        [file]="fileForm"
                        (fileDialogStateChange)="onFileDialogStateChange($event)"
                    ></app-pdf-viewer>
                    &nbsp;
                </div>
            </app-form-group>
        </app-form-row>
    </app-form-section>
</form>
